import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  :root {
    --ink:        #0d0b08;
    --ink-soft:   #16120c;
    --parchment:  #e8dcc4;
    --parchment-2:#cbb992;
    --brass:      #c08b3e;
    --ember:      #8a4b2a;
    --wax:        #7d2a1e;

    --font-display: "Cormorant Garamond", "Iowan Old Style", Georgia, serif;
    --font-body:    "Inter", -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
  }

  *, *::before, *::after { box-sizing: border-box; }

  html, body, #root {
    margin: 0;
    padding: 0;
    background: var(--ink);
    color: var(--parchment);
    font-family: var(--font-body);
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: transparent;
  }

  body {
    overscroll-behavior-y: none;
  }

  /* Locks scrolling on the full-screen stages (letter, portal, historical) */
  body[data-locked="true"] {
    overflow: hidden;
    position: fixed;
    inset: 0;
    width: 100%;
  }

  button {
    font: inherit;
    color: inherit;
    background: none;
    border: none;
    cursor: pointer;
  }

  :focus-visible {
    outline: 2px solid var(--brass);
    outline-offset: 3px;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;

export default GlobalStyle;
